import { useQuery } from '@tanstack/react-query';
import { getFormsByCoverages } from '../api';
import { getData } from '../../../../../utils/functional/fp';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_KEYS } from '../../../../../config/growthbook';

export function useGetFormsByCoverages(
  coverageKeys: string[],
  productKey: string,
  state: string
) {
  const coverageFormsFeatureOn = useFeatureIsOn(
    FEATURE_FLAG_KEYS.COVERAGE_FORMS_ENABLED
  );

  return useQuery({
    queryKey: ['forms-by-coverages', { coverageKeys, productKey, state }],
    queryFn: () =>
      getFormsByCoverages({
        data: { coverageKeys, productKey, state },
      }).then(getData),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled:
      !!coverageKeys.length &&
      !!state &&
      !!productKey &&
      coverageFormsFeatureOn,
  });
}
